import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import IGroupKey from "../interfaces/IGroupKey";
import { GetAttributesByUserID } from "../services/attribute";
import { GetListTypeForm } from "../services/form";


const useListTypeForm = () => {

    // States
    const [listTypeForm, setListTypeForm] = useState<IGroupKey[]>([]);
    const [loadingListTypeForm, setLoadingListTypeForm] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetAttributesByUserID();
    }, [])

    // Handles
    const handleGetAttributesByUserID = () => {
        setLoadingListTypeForm(true);
        tryCatch(() => {
            GetListTypeForm()
                .then((response) => {
                    setListTypeForm(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingListTypeForm(false));
        })
    }

    return {
        listTypeForm,
        loadingListTypeForm,
    }
}


export default useListTypeForm;
